import { Button, Input, tokens } from '@arvoreeducacao/bonsai-ds'
import styled, { css } from 'styled-components'

export const Container = styled.div<{ isOtherLoginMethodsAreaOpen: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 492px;
  padding: ${({ isOtherLoginMethodsAreaOpen }) =>
    isOtherLoginMethodsAreaOpen
      ? `${tokens.spacing.verticalMedium} ${tokens.spacing.horizontalXlarge}`
      : '69px 83px 56px 83px'};
  border-radius: ${tokens.radius.radius_20}px;
  background-color: ${tokens.colors.white};
  box-shadow: ${tokens.shadows.centerLarge};

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    width: 100%;
    padding: 20px 24px 56px 24px;
    border-radius: 0;
  }
`

export const WelcomeText = styled.strong`
  color: ${tokens.colors.dark6};
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.fontSize.xlarge};
  text-align: center;
  margin-bottom: 41px;

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    display: none;
  }
`

export const Division = styled.span<{ a11yEnabled?: boolean }>`
  margin-top: ${tokens.spacing.verticalXlarge};
  width: 100%;
  text-align: center;
  color: ${({ a11yEnabled }) =>
    a11yEnabled ? tokens.colors.dark5 : tokens.colors.dark4};
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.regular};
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.horizontalXsmall};
  margin-bottom: ${tokens.spacing.verticalXlarge};

  &::before,
  &::after {
    content: '';
    display: block;
    background-color: ${tokens.colors.dark2};
    height: 1px;
    flex: 1;
  }
`

export const LoginWith = styled.span<{ a11yEnabled?: boolean }>`
  font-size: ${tokens.fontSize.small};
  color: ${({ a11yEnabled }) =>
    a11yEnabled ? tokens.colors.dark5 : tokens.colors.dark4};
  display: block;
  text-align: center;
  margin-bottom: ${tokens.spacing.verticalSmall};
`

export const ContainerLoginForm = styled.div`
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  text-align: center;
`

export const InputLogin = styled(Input)``

export const ButtonLogin = styled(Button).attrs({
  fluid: true,
  theme: { type: 'primaryLivros', size: 'xLarge' }
})`
  margin-top: ${tokens.spacing.verticalSmall};
`

export const ButtonHelpToLogin = styled.a`
  margin-bottom: 0;
  margin-top: 32px;
  display: none;
  color: ${tokens.colors.dark5};
  text-decoration: underline;
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.bold};
  text-align: center;
  cursor: pointer;

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    display: block;
  }
`

export const ButtonBack = styled(Button)`
  text-decoration: none;
  position: absolute;
  top: ${tokens.spacing.verticalLarge};
  left: ${tokens.spacing.horizontalMedium};

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    position: relative;
    top: auto;
    left: auto;
    align-self: flex-start;
    margin-bottom: ${tokens.spacing.verticalSmall};
  }
`

const loginLinkStyle = css`
  color: ${tokens.colors.dark5};
  text-decoration: underline;
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.bold};
  text-align: center;
  cursor: pointer;
`

export const OtherLoginMethodsAnchor = styled.button`
  background: none;
  border: 0;
  padding: 0;
  font-family: inherit;
  line-height: inherit;
  ${loginLinkStyle}
`

export const ResetAccountAnchor = styled.a`
  ${loginLinkStyle}
  margin-top: ${tokens.spacing.verticalLarge};
`
